
import { Component } from 'react';

import {
    createLiveStreamingDialogEvent,
    sendAnalytics
} from '../../../analytics';
import { MHRecordingConstants } from '../../../base/lib-meet-hour';
import { RECORDING_STOP_REQUESTED } from '../../actionTypes';
import { hidePendingRecordingNotification } from '../../actions';
import { getActiveSession } from '../../functions';

/**
 * The type of the React {@code Component} props of
 * {@link StopLiveStreamDialog}.
 */
type Props = {

    /**
     * The {@code MHConference} for the current conference.
     */
    _conference: Object,

    /**
     * The redux representation of the live stremaing to be stopped.
     */
    _session: Object,

    /**
     * The redux {@code dispatch} function.
     */
    dispatch: Function,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function
};

/**
 * A React Component for confirming the participant wishes to stop the currently
 * active live stream of the conference.
 *
 * @augments Component
 */
export default class AbstractStopLiveStreamDialog extends Component<Props> {
    /**
     * Initializes a new {@code StopLiveStreamDialog} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);

        // Bind event handler so it is only bound once for every instance.
        this._onSubmit = this._onSubmit.bind(this);
    }

    _onSubmit: () => boolean;

    /**
     * Callback invoked when stopping of live streaming is confirmed.
     *
     * @private
     * @returns {boolean} True to close the modal.
     */
    _onSubmit() {
        sendAnalytics(createLiveStreamingDialogEvent('stop', 'confirm.button'));

        const {
            _conference,
            _session,
            _fileRecordingSession,
            _isRecordingandLivestreamingOn,
            dispatch
        } = this.props;

        if (_session) {
            dispatch({
                type: RECORDING_STOP_REQUESTED,
                sessionId: _session.id
            });
            dispatch(hidePendingRecordingNotification(_session.mode));

            _conference && _conference.stopRecording(_session.id);
        }

        if (_isRecordingandLivestreamingOn && _fileRecordingSession) {
            dispatch({
                type: RECORDING_STOP_REQUESTED,
                sessionId: _fileRecordingSession.id
            });
            dispatch(hidePendingRecordingNotification(_fileRecordingSession.mode));

            _conference && _conference.stopRecording(_fileRecordingSession.id);
        }


        return true;
    }
}

/**
 * Maps (parts of) the redux state to the React {@code Component} props of
 * {@code StopLiveStreamDialog}.
 *
 * @param {Object} state - The redux state.
 * @private
 * @returns {{
 *     _conference: Object,
 *     _session: Object
 * }}
 */
export function _mapStateToProps(state: Object) {
    const { isRecordingandLivestreamingOn = false } = state['features/base/mtApi'];

    return {
        _conference: state['features/base/conference'].conference,
        _session: getActiveSession(state, MHRecordingConstants.mode.STREAM),
        _fileRecordingSession: getActiveSession(state, MHRecordingConstants.mode.FILE),
        _isRecordingandLivestreamingOn: isRecordingandLivestreamingOn
    };
}
